/* SS · El Escaparate Vivo — motor de recorrido
   Dos composiciones y una transformacion:
     inicio  · la miel sola, protagonista y comprable
     final   · cuatro categorias estables y clickeables
   Sin librerias, sin secuestro del scroll y sin bucles nuevos: se lee el
   progreso del contenedor pegajoso y se escriben transform y opacity. */
(function () {
  'use strict';

  var MQ_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
  var MQ_WIDE = window.matchMedia('(min-width: 900px)');
  /* Modo animado en movil: solo retrato y con altura suficiente para que la
     compra no quede comprimida. En apaisado corto se conserva el fallback. */
  var MQ_MOB = window.matchMedia('(max-width: 899px) and (orientation: portrait) and (min-height: 650px)');
  var MQ_LOCK = window.matchMedia('(max-width: 899px) and (orientation: portrait)');

  var KEYS = ['mie', 'bot', 'sar', 'mag'];

  /* ------------------------------------------------------------------
     COMPOSICIONES
     Cada fotograma da el punto de APOYO del producto (x del centro, y de
     la base) como fraccion de la escena, y la caja en la que debe caber.
     La escala se deduce de la medida real, nunca es un numero fijo.
     indice 0 = inicio · indice 1 = final
     null en el inicio = el producto no existe todavia: entra en su sitio
     definitivo con un desplazamiento corto y un fundido, sin recorrido.
     ------------------------------------------------------------------ */
  var K = {
    d: {
      mie: [{ x: 0.684, y: 0.940, w: 0.290, h: 0.738 },
        { x: 0.155, y: 0.660, w: 0.150, h: 0.300 }],
      sar: [null, { x: 0.385, y: 0.660, w: 0.150, h: 0.300 }],
      bot: [null, { x: 0.615, y: 0.660, w: 0.150, h: 0.300 }],
      mag: [null, { x: 0.845, y: 0.660, w: 0.150, h: 0.300 }]
    },
    m: {
      mie: [{ x: 0.700, y: 0.940, w: 0.700, h: 0.520 },
        { x: 0.270, y: 0.420, w: 0.400, h: 0.240 }],
      sar: [null, { x: 0.730, y: 0.420, w: 0.400, h: 0.240 }],
      bot: [null, { x: 0.270, y: 0.840, w: 0.400, h: 0.240 }],
      mag: [null, { x: 0.730, y: 0.840, w: 0.400, h: 0.240 }]
    }
  };

  /* ------------------------------------------------------------------
     LINEA DE TIEMPO, en fracciones del recorrido pegajoso.
     0 = el contenedor acaba de quedarse fijo · 1 = se libera.
     Primero se despeja la zona, despues se ocupa: la miel no empieza a
     desplazarse hasta que el bloque editorial y el comercial ya salieron.
     ------------------------------------------------------------------ */
  var T = {
    out0: 0.18, out1: 0.34,   /* editorial y comercial se retiran */
    mie0: 0.34, mie1: 0.66,   /* la miel se reduce y viaja a su categoria */
    oth0: 0.58, oth1: 0.76,   /* los otros tres entran en su sitio */
    lab0: 0.72, lab1: 0.82    /* aparecen los nombres; de 0.82 a 1, estable */
  };
  /* Entrada corta de los tres productos que se revelan, en px hacia arriba. */
  var OTH_RISE = 26;
  /* Punto del recorrido al que lleva el CTA secundario: centro del tramo
     estable de la rejilla, ya formada y todavia pegada. */
  var ANCHOR_P = 0.88;

  /* px entre la base visible del producto y su etiqueta */
  var CAT_GAP = { d: 26, m: 14 };
  /* Aire libre exigido entre la palabra editorial y cualquier producto. */
  var WORD_GAP = 14;
  /* Aire libre exigido en el inicio entre la miel y cualquier texto o boton.
     La miel se pide grande y cede ante este numero, nunca al reves. */
  var EDGE = 16;

  /* Margen transparente de cada activo, como fraccion del lado
     correspondiente de su imagen. Lo unico que se mide para el usuario es
     el producto VISIBLE; la caja nunca lo es. */
  var PAD = { mie: 14 / 480, bot: 13 / 480, mag: 19 / 480, sar: 12 / 480 };
  /* El sarten se dibuja rotado dentro de su caja y el navegador lo ancla al
     borde superior en vez de centrarlo, asi que su contorno visible cuelga
     por debajo. Fraccion fija del alto de la caja, medida sobre el activo. */
  var SAR_OVER = 0.4768;

  var MOB_ENTRY = 520;            /* ms de la entrada inicial, una sola vez */
  var POPUP_ID = 'ss-popup-overlay';

  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function smooth(t) { return t * t * (3 - 2 * t); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function ramp(p, a, b) { return clamp((p - a) / (b - a)); }

  function setInert(el, on) {
    if (!el) return;
    if (on && el.contains(document.activeElement)) return; // no robar el foco
    if ('inert' in el) el.inert = on;
    else if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert');
    el.setAttribute('aria-hidden', on ? 'true' : 'false');
    if (on) el.removeAttribute('data-live'); else el.setAttribute('data-live', '');
  }
  function setVisible(el, on) {
    if (!el) return;
    if (on) el.setAttribute('data-on', ''); else el.removeAttribute('data-on');
  }

  function init(wrap) {
    if (wrap.__ss) return;
    var scene = wrap.querySelector('[data-ss-scene]');
    var stage = wrap.querySelector('[data-ss-stage]');
    var vp = wrap.querySelector('.ss-vp');
    if (!scene || !stage || !vp) return;

    var objs = {}, shs = {}, cats = {};
    KEYS.forEach(function (k) {
      objs[k] = stage.querySelector('[data-ss-obj="' + k + '"]');
      shs[k] = stage.querySelector('[data-ss-sh="' + k + '"]');
      cats[k] = wrap.querySelector('[data-ss-cat="' + k + '"]');
    });
    var lead = wrap.querySelector('[data-ss-lead]');
    /* Columna lateral movil (bajada + CTA secundario). Su ancho lo fija el
       propio borde de la miel, asi que jamas puede solaparla: se excluye de
       la medida del hueco para que no la encoja por realimentacion. */
    var aside = wrap.querySelector('.ss-shop__aside');
    var wordEl = wrap.querySelector('[data-ss-word]');
    var buyA = wrap.querySelector('[data-ss-buy="a"]');
    var catBox = wrap.querySelector('[data-ss-cats]');
    var jump = wrap.querySelector('[data-ss-jump]');
    var anchor = wrap.querySelector('.ss-wrap__anchor');
    if (!catBox) return; // sin la rejilla no hay recorrido que activar

    var base = {}, geo = { W: 0, SH: 1, top: 0, len: 1, stageTop: 0 };
    var mode = '';                 /* '' | 'd' | 'm' */
    var vis = 0, real = 0, running = false, live = false, inView = false;
    var lastState = '', lastCatOn = null, lastBuyOff = null;
    var entry = 1, entryT0 = 0, magSrc = '', magDone = false;
    var held = false, popupWas = false, lockState = null, popObs = null;
    var finMArmed = false, finMObs = false;
    var sarLift = 0, wordH = 0, wordTop = 0, wordOff = 0, wordFit = false;
    var startS = 1, startY = 0;

    /* La banda de cierre vive FUERA del wrap, en el flujo del documento,
       entre el recorrido y el carrusel de categorias. */
    var finM = null;
    for (var sib = wrap.nextElementSibling; sib; sib = sib.nextElementSibling) {
      if (sib.hasAttribute && sib.hasAttribute('data-ss-finale-m')) { finM = sib; break; }
    }

    function clearT() {
      KEYS.forEach(function (k) {
        if (objs[k]) { objs[k].style.transform = ''; objs[k].style.opacity = ''; }
        if (shs[k]) { shs[k].style.transform = ''; shs[k].style.opacity = ''; }
      });
    }

    /* ------------------------------------------------------------------
       POPUP DE PORTADA — deteccion exacta y bloqueo del fondo.
       Solo mira SU contenedor: ni cabecera, ni launcher, ni cajones.
       ------------------------------------------------------------------ */
    function popupEl() { return document.getElementById(POPUP_ID); }

    function popupOpen() {
      var o = popupEl();
      if (!o || !o.isConnected) return false;
      if (!o.classList.contains('active')) return false;
      if (o.getAttribute('aria-hidden') === 'true') return false;
      var cs = window.getComputedStyle(o);
      if (cs.display === 'none' || cs.visibility === 'hidden') return false;
      var r = o.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    }

    /* Con el fondo bloqueado el documento marca 0, asi que la referencia es
       la posicion guardada. Sin bloqueo devuelve exactamente lo de siempre. */
    function scrollNow() {
      if (lockState) return lockState.y;
      return window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    function lockScroll() {
      if (lockState) return;
      var b = document.body, h = document.documentElement;
      var y = window.pageYOffset || h.scrollTop || 0;
      lockState = {
        y: y,
        b: { position: b.style.position, top: b.style.top, left: b.style.left,
          right: b.style.right, width: b.style.width, overflow: b.style.overflow },
        h: { overflow: h.style.overflow, scrollBehavior: h.style.scrollBehavior }
      };
      h.style.scrollBehavior = 'auto';
      b.style.position = 'fixed';
      b.style.top = (-y) + 'px';
      b.style.left = '0';
      b.style.right = '0';
      b.style.width = '100%';
      b.style.overflow = 'hidden';
      h.style.overflow = 'hidden';
      /* Desde el primer bloqueo se vigila la lista de hijos del body: si el
         contenedor del popup desapareciera, el bloqueo se suelta igual. */
      if (popObs) { try { popObs.observe(document.body, { childList: true }); } catch (e) { } }
    }

    function unlockScroll() {
      if (!lockState) return;
      var b = document.body, h = document.documentElement, s = lockState;
      lockState = null;
      b.style.position = s.b.position;
      b.style.top = s.b.top;
      b.style.left = s.b.left;
      b.style.right = s.b.right;
      b.style.width = s.b.width;
      b.style.overflow = s.b.overflow;
      h.style.overflow = s.h.overflow;
      h.style.scrollBehavior = 'auto';
      window.scrollTo(0, s.y);
      h.style.scrollBehavior = s.h.scrollBehavior;
      /* Aqui NO se desconecta el observador: disconnect() vacia la cola de
         registros pendientes y un cierre notificado en ese instante se
         perderia. La vigilancia se queda puesta. */
    }

    function syncLock() {
      if (popupOpen() && MQ_LOCK.matches) lockScroll();
      else unlockScroll();
    }

    function onPopupChange() {
      var o = popupEl();
      if ((!o || !o.isConnected) && popObs) { popObs.disconnect(); popObs = null; }
      var open = popupOpen();
      if (open === popupWas) { syncLock(); return; }
      popupWas = open;
      if (open) {
        syncLock();
        /* La entrada no se gasta detras del scrim. Solo se rebobina si la
           seccion sigue en su inicio: si el usuario ya avanzo, no se toca. */
        if (mode && read() < 0.02) { held = true; entry = 0; apply(vis); }
      } else {
        syncLock();
        if (mode && held) {
          held = false;
          entryT0 = now();
          entry = 0;
          apply(vis);
          sync();
          request();
        }
      }
    }

    function now() {
      return (window.performance && window.performance.now) ? performance.now() : 0;
    }

    /* ------------------------------------------------------------------
       MEDIDA — una sola lectura de layout, en arranque, resize y rotacion.
       ------------------------------------------------------------------ */
    function measure() {
      clearT();
      var wr = wrap.getBoundingClientRect();
      var sc = scene.getBoundingClientRect();
      var st = stage.getBoundingClientRect();
      var sy = scrollNow();
      /* Desplazamiento superior REAL del contenedor pegajoso, leido del
         estilo calculado. Asi el progreso vale 0 justo cuando la escena se
         queda fija y 1 justo cuando se libera, sin compensaciones fijas. */
      var stick = parseFloat(window.getComputedStyle(vp).top) || 0;
      geo.W = sc.width;
      geo.SH = sc.height;
      geo.stageTop = st.top - sc.top;
      geo.top = wr.top + sy - stick;
      geo.len = Math.max(1, wr.height - sc.height);

      /* Destino del CTA secundario, derivado de la geometria REAL: la
         posicion de scroll en la que el progreso vale ANCHOR_P, expresada
         como desplazamiento dentro del contenedor. Sin porcentajes ni
         compensaciones fijas, asi que una cabecera distinta no lo mueve. */
      if (anchor) {
        anchor.style.top =
          Math.round(geo.top + ANCHOR_P * geo.len - (wr.top + sy)) + 'px';
      }

      KEYS.forEach(function (k) {
        var el = objs[k];
        if (!el) return;
        var r = el.getBoundingClientRect();
        base[k] = { cx: r.left + r.width / 2 - sc.left, w: r.width, h: r.height, bt: r.bottom - sc.top };
        var im = el.querySelector('img');
        base[k].ih = im ? im.getBoundingClientRect().height : r.height;
      });

      /* Voladizo del sarten en el fotograma final, en px. */
      sarLift = base.sar ? SAR_OVER * base.sar.h * fit('sar', kf('sar', 1)) : 0;

      /* Etiquetas: centradas en su producto y apoyadas CAT_GAP px por debajo
         de su base VISIBLE. La del sarten usa la misma referencia sin
         corregir que las demas, de modo que las cuatro quedan alineadas. */
      var gap = CAT_GAP[mode];
      KEYS.forEach(function (k) {
        var c = cats[k], f = kf(k, 1);
        if (!c || !base[k] || !f) return;
        c.style.setProperty('--cat-x', Math.round(f.x * geo.W));
        /* El sarten llega a su fotograma final subido su propio voladizo,
           asi que su base visible cae justo en la linea de la caja. */
        var vb = f.y * geo.SH - (k === 'sar' ? 0 : PAD[k] * base[k].h * fit(k, f));
        var b = geo.SH - vb - gap - c.getBoundingClientRect().height;
        c.style.setProperty('--cat-b', Math.max(6, Math.round(b)) + 'px');
        /* Zona tactil: la celda entera, imagen y nombre, es un solo enlace.
           Se dibuja hacia arriba con un pseudoelemento para no alterar la
           caja que acaba de medirse. */
        c.style.setProperty('--cat-hit',
          Math.round(gap + base[k].ih * fit(k, f) + (k === 'sar' ? sarLift : 0)) + 'px');
      });

      fitStart();

      /* Borde izquierdo VISIBLE de la miel en el fotograma de inicio, en px de
         escena. Lo publica el motor para que la columna lateral movil se
         dimensione con la silueta REAL y no con un porcentaje: asi nunca la
         invade, sea cual sea la escala que haya decidido la biseccion. Como esa
         columna no comparte franja horizontal con el frasco, no entra en el
         calculo de su tamano y no hay realimentacion posible. En escritorio
         ninguna regla lee esta variable. */
      if (base.mie) {
        var a0 = kf('mie', 0);
        if (a0 && base.mie.w && base.mie.h) {
          wrap.style.setProperty('--sss-mie-l',
            Math.round(a0.x * geo.W
              - (base.mie.w - 2 * PAD.mie * base.mie.h) * startS / 2) + 'px');
        }
      }

      measureWord();
      if (!magSrc) {
        var m = document.querySelector('img[src*="magnesio-m"]');
        if (m) magSrc = m.getAttribute('src') || '';
      }
    }

    /* Rectangulos que ocupa de verdad un bloque, en coordenadas de la
       escena: la TINTA de cada linea de texto y la CAJA de cada boton o
       enlace. Se mide lo que se ve, no la caja del parrafo: un nombre corto
       no reserva todo el ancho de su columna. El tercer argumento permite
       omitir un subarbol entero -la columna lateral movil-.
       Cada entrada es [izquierda, derecha, arriba, abajo]. */
    function boxesOf(el, sc, skip) {
      var out = [], rng = document.createRange();
      var bt = el.querySelectorAll('a, button');
      for (var i = 0; i < bt.length; i++) {
        if (skip && skip.contains(bt[i])) continue;
        var br = bt[i].getBoundingClientRect();
        if (br.width > 0 && br.height > 0) {
          out.push([br.left - sc.left, br.right - sc.left, br.top - sc.top, br.bottom - sc.top]);
        }
      }
      (function walk(n) {
        if (skip && n === skip) return;
        if (n.nodeType === 3) {
          if (!n.nodeValue || !n.nodeValue.replace(/\s+/g, '')) return;
          rng.selectNodeContents(n);
          var rl = rng.getClientRects();
          for (var j = 0; j < rl.length; j++) {
            if (rl[j].width > 0 && rl[j].height > 0) {
              out.push([rl[j].left - sc.left, rl[j].right - sc.left,
                rl[j].top - sc.top, rl[j].bottom - sc.top]);
            }
          }
          return;
        }
        for (var c = n.firstChild; c; c = c.nextSibling) walk(c);
      })(el);
      return out;
    }

    /* Tamano y apoyo de la miel en el inicio. Se pide la pose deseada y se
       recorta a la franja libre REAL: por arriba, lo ultimo que escribe el
       bloque editorial; por abajo, lo primero que el bloque comercial
       escribe o hace pulsable. Solo cuentan los elementos que comparten
       franja horizontal con la silueta, asi que ni el editorial de la
       izquierda en escritorio ni la columna lateral movil la limitan: cada
       linea de texto y cada boton se miden por separado, nunca como un
       rectangulo unico que envuelva a todos. El aumento se ajusta al espacio
       de cada pantalla en vez de a un porcentaje fijo: el CTA nunca se
       sacrifica. */
    function fitStart() {
      var a = kf('mie', 0), b = base.mie;
      startS = (a && b) ? fit('mie', a) : 1;
      startY = a ? a.y * geo.SH : 0;
      if (!a || !b || !b.w || !b.h) return;
      var sc = scene.getBoundingClientRect();
      /* El bloque editorial puede estar retirado en el momento de medir: se
         descuenta su desplazamiento para leer siempre su sitio de reposo. */
      var ly = parseFloat(window.getComputedStyle(wrap).getPropertyValue('--sss-lead-y')) || 0;
      var up = [], dn = [];
      /* En movil el titular superior y la columna lateral se miden por
         separado: solo el titular puede ponerle techo a la miel. La columna
         se salta porque su ancho SALE del borde del frasco -20 px de aire-,
         de modo que incluirla crearia un lazo: la miel se encogeria para
         apartarse de una columna que solo existe donde la miel no esta. */
      var skipEl = (mode === 'm') ? aside : null;
      if (lead) boxesOf(lead, sc, skipEl).forEach(function (q) { up.push([q[0], q[1], q[3] - ly]); });
      if (buyA) boxesOf(buyA, sc).forEach(function (q) { dn.push([q[0], q[1], q[2]]); });

      var vw0 = b.w - 2 * PAD.mie * b.h;      /* silueta visible a escala 1 */
      var vh0 = b.h * (1 - 2 * PAD.mie);
      var cx = a.x * geo.W;
      var band = { lo: 0, hi: geo.SH };

      /* Franja libre para una silueta de escala s: solo limitan los
         elementos que de verdad comparten franja horizontal con ella. */
      function room(s) {
        var vw = vw0 * s, l = cx - vw / 2, rt = cx + vw / 2;
        var lo = 0, hi = geo.SH, i, q;
        for (i = 0; i < up.length; i++) {
          q = up[i];
          if (q[1] + EDGE > l && q[0] - EDGE < rt && q[2] + EDGE > lo) lo = q[2] + EDGE;
        }
        for (i = 0; i < dn.length; i++) {
          q = dn[i];
          if (q[1] + EDGE > l && q[0] - EDGE < rt && q[2] - EDGE < hi) hi = q[2] - EDGE;
        }
        band.lo = lo;
        band.hi = hi;
        return hi - lo;
      }

      /* Crecer ensancha la silueta, y ensanchar solo puede estrechar la
         franja: la holgura decrece con la escala, asi que una biseccion
         encuentra la mayor miel que cabe. Se pide la pose deseada y se cede
         hasta donde haga falta; nunca al reves. */
      var hiS = startS, loS = 0.08;
      if (vh0 * hiS > room(hiS)) {
        for (var it = 0; it < 26; it++) {
          var mid = (loS + hiS) / 2;
          if (vh0 * mid <= room(mid)) loS = mid; else hiS = mid;
        }
        startS = loS;
        room(startS);
      }
      var vh = vh0 * startS, pd = PAD.mie * b.h * startS;
      var yb = Math.min(a.y * geo.SH, band.hi + pd);
      if (yb - pd - vh < band.lo) yb = band.lo + vh + pd;
      startY = yb;
    }

    /* Franja propia de la palabra editorial en la composicion final. En
       escritorio encabeza las cuatro columnas; en movil ocupa el pasillo
       central de la rejilla, que es la unica franja que no queda tapada por
       la cabecera cuando el pegajoso se libera. Si no cupiera con su aire a
       cada lado, la palabra no se muestra en vez de invadir nada. */
    function measureWord() {
      wordFit = false;
      wordH = 0;
      wordOff = 0;
      if (!wordEl) return;
      /* Alto REAL pintado: la caja de linea de una tipografia puede sobresalir
         de la caja del elemento cuando el interlineado es menor que 1. Se mide
         lo que se ve y se guarda cuanto sobresale por arriba, para que la
         palabra caiga exactamente donde se ha reservado su franja. */
      var er = wordEl.getBoundingClientRect(), wt = er.top, wb = er.bottom;
      try {
        var rg = document.createRange();
        rg.selectNodeContents(wordEl);
        var rl = rg.getClientRects();
        for (var i = 0; i < rl.length; i++) {
          if (rl[i].height <= 0) continue;
          if (rl[i].top < wt) wt = rl[i].top;
          if (rl[i].bottom > wb) wb = rl[i].bottom;
        }
      } catch (e) { }
      wordH = wb - wt;
      wordOff = er.top - wt;
      if (!wordH) return;
      var lo, hi;
      if (mode === 'd') {
        lo = 0;
        hi = 1e9;
        KEYS.forEach(function (k) {
          var f = kf(k, 1);
          if (!base[k] || !f) return;
          hi = Math.min(hi, f.y * geo.SH - base[k].h * fit(k, f) * (1 - PAD[k]));
        });
      } else {
        lo = 0;
        hi = 1e9;
        KEYS.forEach(function (k) {
          var f = kf(k, 1), c = cats[k];
          if (!base[k] || !f) return;
          if (f.y < 0.6) {
            if (c) lo = Math.max(lo, f.y * geo.SH + CAT_GAP[mode] + c.getBoundingClientRect().height);
          } else {
            hi = Math.min(hi, f.y * geo.SH - base[k].h * fit(k, f) * (1 - PAD[k]));
          }
        });
      }
      wordFit = (hi - lo) >= wordH + 2 * WORD_GAP;
      wordTop = wordFit ? lo + (hi - lo - wordH) / 2 + wordOff : 0;
    }

    function kf(k, i) {
      var t = K[mode];
      return t && t[k] ? t[k][i] : null;
    }

    /* Escala que hace caber el producto en su caja sin deformarlo. */
    function fit(k, f) {
      var b = base[k];
      if (!f || !b || !b.w || !b.h) return 1;
      var s = Math.min(f.w * geo.W / b.w, f.h * geo.SH / b.h);
      return s < 0.12 ? 0.12 : s > 2.2 ? 2.2 : s;
    }

    /* Fotograma de un objeto. La miel interpola de forma continua entre sus
       dos poses; los otros tres solo existen en la final. */
    function frame(k, p) {
      var a = kf(k, 0), c = kf(k, 1), b = base[k];
      if (!b || !c) return null;
      var s1 = fit(k, c);
      var y1 = c.y * geo.SH - (k === 'sar' ? sarLift : 0);
      if (!a) {
        var e = smooth(ramp(p, T.oth0, T.oth1));
        return { x: c.x * geo.W - b.cx, y: y1 - b.bt + (1 - e) * OTH_RISE, s: s1, o: e };
      }
      var t = smooth(ramp(p, T.mie0, T.mie1));
      return {
        x: lerp(a.x * geo.W, c.x * geo.W, t) - b.cx,
        y: lerp(startY, y1, t) - b.bt,
        s: lerp(startS, s1, t),
        o: 1
      };
    }

    function read() { return clamp((scrollNow() - geo.top) / geo.len); }

    /* ------------------------------------------------------------------
       PINTADO
       ------------------------------------------------------------------ */
    function apply(p) {
      /* Entrada inicial, una sola vez. El reloj avanza aqui y no en el
         bucle, para que cualquier via de llamada la resuelva: si el motor
         nunca corriera, la escena no se queda con un producto invisible. */
      if (entry < 1) {
        if (held) entry = 0;
        else {
          entry = (now() - entryT0) / MOB_ENTRY;
          if (entry > 1) entry = 1;
          if (entry < 0) entry = 0;
        }
      }
      var en = smooth(entry), eo = 1 - en;

      /* El magnesio se pide justo antes de necesitarlo, no en la carga. */
      if (!magDone && magSrc && p >= T.oth0 - 0.12 && objs.mag) {
        var mi = objs.mag.querySelector('img');
        if (mi && /^data:/.test(mi.getAttribute('src') || '')) { mi.src = magSrc; }
        magDone = true;
      }

      KEYS.forEach(function (k) {
        var f = frame(k, p);
        if (!f) return;
        var op = f.o;
        if (eo > 0 && k === 'mie') {
          /* La miel entra creciendo un 3 % desde su propia base, nunca
             desplazandose: durante la entrada la silueta queda DENTRO de
             su sitio definitivo y el aire con el CTA no se toca. Al
             encoger, el margen transparente encoge con ella y la base
             VISIBLE bajaria unas decimas de pixel: se compensa exacta.
             La opacidad no baja de 0.25: aunque solo se pintara un
             fotograma, el producto nunca queda invisible. */
          var ds = 0.03 * eo;
          f.y -= PAD.mie * base.mie.h * f.s * ds;
          f.s *= 1 - ds;
          op *= 0.25 + 0.75 * en;
        }
        var el = objs[k];
        if (el) {
          el.style.transform = 'translate3d(' + f.x.toFixed(1) + 'px,' + f.y.toFixed(1) + 'px,0) scale(' + f.s.toFixed(3) + ')';
          el.style.opacity = op.toFixed(3);
        }
        var s = shs[k];
        if (s) {
          s.style.transform = 'translate3d(' + f.x.toFixed(1) + 'px,' + f.y.toFixed(1) + 'px,0) scaleX(' + f.s.toFixed(3) + ')';
          s.style.opacity = (op * (1 - 0.45 * ramp(p, T.mie0, T.mie1))).toFixed(3);
        }
      });

      /* Primero se despeja la zona: titular, apoyo y bloque comercial salen
         antes de que la miel empiece a moverse. */
      var o = 1 - ramp(p, T.out0, T.out1);
      wrap.style.setProperty('--sss-lead', o.toFixed(3));
      wrap.style.setProperty('--sss-lead-y', (-22 * (1 - o)).toFixed(1));
      wrap.style.setProperty('--sss-a', o.toFixed(3));
      if (lead) { if (o < 0.02) lead.setAttribute('data-off', ''); else lead.removeAttribute('data-off'); }
      var off = o < 0.02;
      if (buyA && off !== lastBuyOff) {
        lastBuyOff = off;
        if (off) buyA.setAttribute('data-off', ''); else buyA.removeAttribute('data-off');
        setInert(buyA, off);
      }

      /* Los nombres aparecen con la composicion practicamente resuelta. */
      var c = ramp(p, T.lab0, T.lab1);
      wrap.style.setProperty('--sss-c', c.toFixed(3));
      setVisible(catBox, c > 0.02);

      /* La palabra editorial no aparece en el inicio y nunca queda detras de
         un producto: solo se dibuja en su franja de la composicion final. */
      var w = wordFit ? ramp(p, T.lab0, T.lab1) : 0;
      wrap.style.setProperty('--sss-word', w.toFixed(4));
      wrap.style.setProperty('--sss-word-t', ((wordFit ? wordTop : 0) - geo.stageTop).toFixed(1) + 'px');

      wrap.style.setProperty('--sss-ground', (0.34 * geo.SH * smooth(ramp(p, T.out0, T.mie1))).toFixed(1) + 'px');
      wrap.style.setProperty('--sss-p', p.toFixed(4));

      var q = Math.round(p * 10000) / 10000;
      var st = q <= T.out0 ? (mode === 'd' ? 'e1' : 'm1')
        : q < T.lab1 ? 'transition' : (mode === 'd' ? 'e3' : 'm3');
      if (st !== lastState) { lastState = st; scene.setAttribute('data-state', st); }

      /* Las cuatro celdas son enlaces reales y solo lo son con la rejilla ya
         formada. Siguen utilizables mientras la composicion se ve, tambien
         despues de liberarse el pegajoso: el criterio es la propia rejilla,
         no que el progreso haya llegado a 1. Fuera de ahi son inertes, de
         modo que jamas hay un enlace enfocable bajo aria-hidden. */
      var catOn = c > 0.9;
      if (catOn !== lastCatOn) {
        lastCatOn = catOn;
        setInert(catBox, !catOn);
        KEYS.forEach(function (k) { if (cats[k]) cats[k].tabIndex = catOn ? 0 : -1; });
      }
    }

    /* ------------------------------------------------------------------
       BANDA DE CIERRE — una entrada, una sola vez, con su propio
       IntersectionObserver. Sin rAF nuevo y sin temporizadores.
       ------------------------------------------------------------------ */
    function armFinale() {
      if (finMObs || !finM || !window.IntersectionObserver) return;
      var io2;
      try {
        io2 = new IntersectionObserver(function (e) {
          if (!e[0].isIntersecting) {
            /* La banda se oculta DESDE DENTRO del primer aviso, es decir
               solo cuando consta que el observador esta entregando. Si
               nunca entregara un aviso, nunca se arma y se queda visible,
               que es el estado seguro. */
            if (!finMArmed) { finMArmed = true; finM.setAttribute('data-armed', ''); }
            return;
          }
          finM.removeAttribute('data-armed');
          io2.disconnect();
        }, { rootMargin: '0px 0px -10% 0px' });
      } catch (e) { return; }
      finMObs = true;
      io2.observe(finM);
    }

    /* Red de seguridad de la banda: mientras siga oculta esperando su
       entrada, cada evento de scroll comprueba con una sola medida si ya
       esta a la vista y la revela. Asi la banda no depende de que llegue
       un segundo aviso del observador: si el navegador estuviera sin
       pintar, el scroll la descubre igual. En cuanto se revela, esta
       comprobacion se apaga sola y vuelve a costar una condicion. */
    function checkFinale() {
      if (!finMArmed || !finM) return;
      var r = finM.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight * 0.9) {
        finMArmed = false;
        finM.removeAttribute('data-armed');
      }
    }

    /* ------------------------------------------------------------------
       MODOS
       ------------------------------------------------------------------ */
    function enable(m) {
      if (mode === m) return;
      if (mode) disable();
      mode = m;
      wrap.classList.add(m === 'd' ? 'ss-cine' : 'ss-mobile-cine');
      if (jump && jump.dataset.cineHref) jump.href = jump.dataset.cineHref;
      try {
        measure();
        entry = 0;
        held = popupOpen();
        entryT0 = now();
        vis = real = read();
        apply(vis);
        armFinale();
      } catch (e) {
        disable();
      }
    }

    function disable() {
      if (!mode) return;
      wrap.classList.remove('ss-cine', 'ss-mobile-cine', 'is-live');
      mode = '';
      live = false;
      running = false;
      entry = 1;
      held = false;
      lastBuyOff = null;
      lastCatOn = null;
      clearT();
      ['--sss-lead', '--sss-lead-y', '--sss-a', '--sss-c', '--sss-word', '--sss-word-t',
        '--sss-ground', '--sss-p', '--sss-mie-l']
        .forEach(function (v) { wrap.style.removeProperty(v); });
      setVisible(catBox, false);
      setInert(catBox, true);
      KEYS.forEach(function (k) { if (cats[k]) cats[k].tabIndex = -1; });
      if (lead) lead.removeAttribute('data-off');
      if (buyA) buyA.removeAttribute('data-off');
      setInert(buyA, false);
      if (jump) jump.href = jump.getAttribute('data-fallback-href');
      if (anchor) anchor.style.top = '';
      scene.setAttribute('data-state', 'e1');
      lastState = '';
    }

    /* Unico punto que elige el modo. Nunca hay dos activos a la vez. */
    function pickMode() {
      if (MQ_MOTION.matches) { disable(); return; }
      if (MQ_WIDE.matches) enable('d');
      else if (MQ_MOB.matches) enable('m');
      else disable();
    }

    /* ------------------------------------------------------------------
       BUCLE — uno solo, compartido por los dos modos.
       ------------------------------------------------------------------ */
    function tick() {
      running = false;
      if (!live || !mode) return;
      real = read();
      var d = real - vis;
      if (Math.abs(d) > 0.35) vis = real;          /* ancla, teclado, restauracion */
      else if (Math.abs(d) < 0.0008) vis = real;
      else vis += d * 0.26;
      apply(vis);
      if (vis !== real || (entry < 1 && !held)) request();
    }
    function request() {
      if (running || !live) return;
      running = true;
      requestAnimationFrame(tick);
    }
    function onScroll() { checkFinale(); request(); }

    function setLive(on) {
      if (on === live) return;
      live = on;
      if (on) { wrap.classList.add('is-live'); request(); }
      else { wrap.classList.remove('is-live'); }
    }
    function sync() { setLive(inView && !document.hidden && !!mode); }

    function refresh() {
      onPopupChange();
      pickMode();
      if (mode) { measure(); vis = real = read(); apply(vis); }
      sync();
    }

    if (jump) jump.setAttribute('data-fallback-href', jump.getAttribute('href'));

    var io = new IntersectionObserver(function (e) {
      inView = e[0].isIntersecting;
      sync();
    }, { rootMargin: '10% 0px' });
    io.observe(wrap);

    var rt;
    function onResize() {
      clearTimeout(rt);
      rt = setTimeout(refresh, 140);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('orientationchange', onResize, { passive: true });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { setLive(false); return; }
      refresh();
    });
    if (MQ_MOTION.addEventListener) MQ_MOTION.addEventListener('change', function () {
      if (MQ_MOTION.matches) { disable(); setLive(false); } else onResize();
    });

    /* Un solo MutationObserver, acotado al contenedor del popup y a los
       atributos que expresan su estado. Sin sondeo y sin otro rAF. */
    try {
      var pel = popupEl();
      if (pel && window.MutationObserver) {
        popObs = new MutationObserver(onPopupChange);
        popObs.observe(pel, { attributes: true, attributeFilter: ['class', 'style', 'aria-hidden'] });
        popupWas = popupOpen();
        syncLock();
      }
    } catch (e) { unlockScroll(); }

    pickMode();
    wrap.__ss = true;
  }

  function boot() {
    if (MQ_MOTION.matches) return; // no se inicializa el motor
    var list = document.querySelectorAll('[data-ss-wrap]');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();